/**
 * Main Product Section
 * Handles gallery, variants, personalization, quantity, and AJAX add to cart
 */

(function () {
  'use strict';

  const productJson = JSON.parse(document.getElementById('product-json')?.textContent || '{}');
  const productData = productJson.product || productJson;
  const shopData = productJson.shop || {};

  if (productJson.variants_inventory && Array.isArray(productJson.variants_inventory)) {
    const inventoryMap = {};
    productJson.variants_inventory.forEach(inv => {
      inventoryMap[inv.id] = inv;
    });
    (productData.variants || []).forEach(variant => {
      const inv = inventoryMap[variant.id];
      if (inv) {
        if (variant.inventory_policy === undefined) variant.inventory_policy = inv.inventory_policy;
        if (variant.inventory_quantity === undefined) variant.inventory_quantity = inv.inventory_quantity;
        if (variant.inventory_management === undefined) variant.inventory_management = inv.inventory_management;
      }
    });
  } else {
    console.warn('[ATC Debug] ⚠️ variants_inventory not found in product-json. inventory_policy/inventory_quantity will be undefined. Add the variants_inventory block to your Liquid template.');
  }

  // Thumbnail Gallery
  function initGallery() {
    const thumbnails = document.querySelectorAll('.product__thumbnail');
    const mainImage = document.getElementById('product-main-image');

    if (!mainImage || thumbnails.length === 0) return;

    thumbnails.forEach(thumb => {
      thumb.addEventListener('click', function () {
        const imageUrl = this.dataset.imageUrl;
        const zoomUrl = this.dataset.zoomUrl;
        const imageAlt = this.dataset.imageAlt;

        mainImage.src = imageUrl;
        mainImage.alt = imageAlt;
        mainImage.dataset.zoom = zoomUrl;

        thumbnails.forEach(t => t.classList.remove('is-active'));
        this.classList.add('is-active');
      });
    });
  }

  // Size Selection with League Dropdowns
  function initSizeSelector() {
    const sizeButtons = document.querySelectorAll('.product__size-btn.js-size-dropdown');

    sizeButtons.forEach(btn => {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (this.disabled) return;

        const sizeValue = this.dataset.size;
        // Find dropdown by data-size attribute
        const dropdown = document.querySelector(`.product__league-dropdown[data-size="${sizeValue}"]`);
        const isCurrentlyOpen = dropdown && dropdown.classList.contains('is-open');

        // Toggle size selection (radio behavior)
        sizeButtons.forEach(b => {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
          b.setAttribute('aria-expanded', 'false');

          // Close all dropdowns
          const allDropdowns = document.querySelectorAll('.product__league-dropdown');
          allDropdowns.forEach(d => {
            d.classList.remove('is-open');
            d.classList.add('is-closed');
            d.setAttribute('aria-hidden', 'true');
          });
        });

        this.classList.add('is-active');
        this.setAttribute('aria-pressed', 'true');

        // Toggle dropdown for this size
        if (dropdown && !isCurrentlyOpen) {
          dropdown.classList.remove('is-closed');
          dropdown.classList.add('is-open');
          dropdown.setAttribute('aria-hidden', 'false');
          this.setAttribute('aria-expanded', 'true');
        } else if (dropdown && isCurrentlyOpen) {
          dropdown.classList.remove('is-open');
          dropdown.classList.add('is-closed');
          dropdown.setAttribute('aria-hidden', 'true');
          this.setAttribute('aria-expanded', 'false');
        }

        // Update variant if a league is already selected for this size
        updateVariant();
      });
    });

    // Close dropdowns when clicking outside
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.product__size-wrapper') && !e.target.closest('.product__league-dropdown')) {
        const allDropdowns = document.querySelectorAll('.product__league-dropdown');
        allDropdowns.forEach(d => {
          d.classList.remove('is-open');
          d.classList.add('is-closed');
          d.setAttribute('aria-hidden', 'true');
        });
        sizeButtons.forEach(btn => {
          btn.setAttribute('aria-expanded', 'false');
        });
      }
    });
  }

  // League Checkbox Selection
  function initLeagueSelector() {
    const leagueCheckboxes = document.querySelectorAll('.product__league-checkbox input[type="checkbox"]');

    leagueCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', function () {
        if (this.disabled) return;

        const sizeValue = this.dataset.size;

        // Radio behavior: uncheck other league checkboxes for the same size
        const sameSizeCheckboxes = document.querySelectorAll(
          `.product__league-checkbox input[data-size="${sizeValue}"]`
        );

        sameSizeCheckboxes.forEach(cb => {
          if (cb !== this) {
            cb.checked = false;
          }
        });

        // Keep dropdown open after selection (as per design)

        updateVariant();
      });
    });
  }

  function initStyleTabs() {
    const styleTabs = document.querySelectorAll('.custom-option-button.js-style-tab');

    styleTabs.forEach(tab => {
      const selectId = tab.closest('.product__style-options').dataset.selectId;
      const personalizationDropdown = tab.closest('.product__option').querySelector('.js-personalization');

      const personalizationBtn = tab.classList.contains('js-personalization-dropdown') ? tab : null;

      tab.addEventListener('click', function (e) {
        e.stopPropagation();

        const isPersonalizationBtn = this.classList.contains('js-personalization-dropdown');
        const isCurrentlyOpen = personalizationDropdown && personalizationDropdown.classList.contains('is-open');

        if (isPersonalizationBtn && personalizationDropdown) {
          const optionGroup = tab.closest('.custom-option-buttons');
          if (isCurrentlyOpen) {
            // Close dropdown and activate first non-personalized tab (team tab) in this option only
            personalizationDropdown.classList.remove('is-open');
            personalizationDropdown.setAttribute('aria-hidden', 'true');

            if (optionGroup) {
              optionGroup.querySelectorAll('.custom-option-button').forEach(t => {
                const isTeamTab = !t.classList.contains('js-personalization-dropdown');
                t.classList.toggle('active', isTeamTab);
                t.classList.toggle('is-active', isTeamTab);
                t.setAttribute('aria-pressed', isTeamTab ? 'true' : 'false');
                t.setAttribute('aria-expanded', 'false');
              });
            }
          } else {
            // Open dropdown and activate personalized tab in this option only
            personalizationDropdown.classList.add('is-open');
            personalizationDropdown.setAttribute('aria-hidden', 'false');

            if (optionGroup) {
              optionGroup.querySelectorAll('.custom-option-button').forEach(t => {
                const isPersonalizedTab = t.classList.contains('js-personalization-dropdown');
                t.classList.toggle('active', isPersonalizedTab);
                t.classList.toggle('is-active', isPersonalizedTab);
                t.setAttribute('aria-pressed', isPersonalizedTab ? 'true' : 'false');
                t.setAttribute('aria-expanded', isPersonalizedTab ? 'true' : 'false');
              });
            }
          }
        } else {
          // Non-personalization tab clicked - close dropdown and activate clicked tab (only within this option group)
          if (personalizationDropdown) {
            personalizationDropdown.classList.remove('is-open');
            personalizationDropdown.setAttribute('aria-hidden', 'true');
          }

          const optionGroup = tab.closest('.custom-option-buttons');
          if (optionGroup) {
            optionGroup.querySelectorAll('.custom-option-button').forEach(t => {
              const isClickedTab = t === tab;
              t.classList.toggle('active', isClickedTab);
              t.classList.toggle('is-active', isClickedTab);
              t.setAttribute('aria-pressed', isClickedTab ? 'true' : 'false');
              t.setAttribute('aria-expanded', 'false');
            });
          }
        }

        // Sync hidden select
        const hiddenSelect = tab.closest('.product__option').querySelector('select');
        if (hiddenSelect) {
          hiddenSelect.value = tab.dataset.value;
          hiddenSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }

  function syncStyleTabsWithVariant() {
    const select = document.querySelector('#option-style');
    const personalizationDropdown = document.querySelector('.js-personalization');
    const styleTabs = document.querySelectorAll('.js-style-tab');

    if (!select || !personalizationDropdown || !styleTabs.length) return;

    const selectedValue = select.value.toLowerCase();
    const isPersonalized = selectedValue.includes('personalized');

    if (isPersonalized) {
      // Open personalization dropdown
      personalizationDropdown.classList.add('is-open');
      personalizationDropdown.setAttribute('aria-hidden', 'false');

      // Activate personalized tab
      styleTabs.forEach(t => {
        const isPersonalizedTab = t.classList.contains('js-personalization-dropdown');
        t.classList.toggle('is-active', isPersonalizedTab);
        t.setAttribute('aria-pressed', isPersonalizedTab ? 'true' : 'false');
        t.setAttribute('aria-expanded', isPersonalizedTab ? 'true' : 'false');
      });
    }
  }


  // League Checkbox Selection in Style Section
  function initStyleLeagueSelector() {
    const styleLeagueCheckboxes = document.querySelectorAll('.product__league.js-league .product__league-checkbox input[type="checkbox"]');

    styleLeagueCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', function () {
        if (this.disabled) return;

        // Radio behavior: uncheck other league checkboxes in style section
        const allStyleCheckboxes = document.querySelectorAll('.product__league.js-league .product__league-checkbox input[type="checkbox"]');

        allStyleCheckboxes.forEach(cb => {
          if (cb !== this) {
            cb.checked = false;
          }
        });

        updateVariant();
      });
    });
  }

  // Get variant's option value by index (supports .options array or .option1/.option2/.option3)
  function getVariantOptionValue(variant, index) {
    if (variant.options && variant.options[index] !== undefined) return variant.options[index];
    return variant['option' + (index + 1)];
  }

  // Given current selection, return set of values that are available for this option (have an available variant)
  function getAvailableValuesForOption(selectedOptions, optionIndex) {
    const variants = productData.variants || [];
    const available = new Set();
    const norm = (x) => (x == null ? '' : String(x).trim());
    variants.forEach((v) => {
      if (!v.available) return;
      let matches = true;
      for (let i = 0; i < selectedOptions.length; i++) {
        if (i === optionIndex) continue;
        const sel = selectedOptions[i];
        if (sel == null) continue;
        const optVal = getVariantOptionValue(v, i);
        if (norm(optVal) !== norm(sel)) {
          matches = false;
          break;
        }
      }
      if (matches) {
        const val = getVariantOptionValue(v, optionIndex);
        if (val != null) available.add(norm(val));
      }
    });
    return available;
  }

  // Enable/disable option buttons based on current selection so only valid combinations show as selectable
  function updateOptionAvailability(selectedOptions) {
    const productOptions = productData.options || [];
    
    // Process Size option last so it can be filtered based on color selection
    const sizeIndex = productOptions.findIndex(name => name === 'Size');
    const otherOptions = productOptions.map((name, index) => ({ name, index }))
      .filter(item => item.name !== 'Size' && item.name !== 'League' && item.name !== 'Title');
    
    otherOptions.forEach(({ name: optionName, index }) => {
      const position = index + 1;
      const select = document.querySelector(`.product__option select[data-option-index="${position}"]`);
      if (!select) return;
      const optionBlock = select.closest('.product__option');
      const group = optionBlock && optionBlock.querySelector('.custom-option-buttons');
      if (!group) return;
      
      group.querySelectorAll('.custom-option-button').forEach((btn) => {
        btn.disabled = false;
        btn.setAttribute('aria-disabled', 'false');
        btn.classList.remove('is-disabled');
      });
    });
    
    if (sizeIndex !== -1) {
      const index = sizeIndex;
      const available = getAvailableValuesForOption(selectedOptions, index);
      const currentValue = selectedOptions[index];
      const normVal = (x) => (x == null ? '' : String(x).trim());

      const sizeButtons = document.querySelectorAll('.product__size-btn.js-size-dropdown');
      let firstAvailable = null;
      sizeButtons.forEach((btn) => {
        const val = normVal(btn.dataset.optionValue || btn.dataset.size);
        const isAvailable = val && available.has(val);
        btn.disabled = !isAvailable;
        btn.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
        btn.classList.toggle('is-disabled', !isAvailable);
        if (isAvailable && !firstAvailable) firstAvailable = btn;
      });
      // If current size is no longer available for selected color, select first available size
      if (currentValue && !available.has(normVal(currentValue)) && firstAvailable) {
        sizeButtons.forEach((b) => {
          b.classList.remove('is-active');
          b.classList.remove('active');
          b.setAttribute('aria-pressed', 'false');
        });
        firstAvailable.classList.add('is-active', 'active');
        firstAvailable.setAttribute('aria-pressed', 'true');
      }
    }
  }

  function buildSelectedOptionsFromDOM() {
    const productOptions = productData.options || [];
    const selectedOptions = [];
    productOptions.forEach((optionName, index) => {
      const position = index + 1;
      let selectedValue = null;
      if (optionName === 'League') {
        const checkedStyleLeague = document.querySelector('.product__league.js-league .product__league-checkbox input[type="checkbox"]:checked');
        const checkedSizeLeague = document.querySelector('.product__league-dropdown .product__league-checkbox input[type="checkbox"]:checked');
        const checkedLeague = checkedStyleLeague || checkedSizeLeague;
        if (checkedLeague) selectedValue = checkedLeague.dataset.optionValue;
      } else if (optionName === 'Size') {
        const activeSize = document.querySelector('.product__size-btn.is-active') || document.querySelector('.product__size-btn.active');
        if (activeSize && !activeSize.disabled) selectedValue = activeSize.dataset.optionValue || activeSize.dataset.size;
      } else if (optionName !== 'Title') {
        const select = document.querySelector(`.product__option select[data-option-index="${position}"]`);
        if (select) selectedValue = select.value || null;
      }
      selectedOptions.push(selectedValue);
    });
    return selectedOptions;
  }

  // Update variant based on selected options
  function updateVariant() {
    const productOptions = productData.options || [];
    let selectedOptions = buildSelectedOptionsFromDOM();

    // Update which option values are available (disable sizes/colors that have no variant for current selection)
    updateOptionAvailability(selectedOptions);

    // Rebuild in case we auto-selected a different size/option
    selectedOptions = buildSelectedOptionsFromDOM();

    // Find matching variant (support both .options array and .option1/.option2/.option3)
    const normOpt = (x) => (x == null ? '' : String(x).trim());
    const variant = productData.variants?.find((v) => {
      return selectedOptions.every((sel, i) => {
        if (sel == null) return true;
        const optVal = getVariantOptionValue(v, i);
        return normOpt(optVal) === normOpt(sel);
      });
    });

    if (variant) {
      updateVariantUI(variant);
    }
  }

  function updateVariantUI(variant) {
    // Update hidden input
    const variantInput = document.getElementById('product-variant-id');
    if (variantInput) variantInput.value = variant.id;

    // Update price (use store's "with currency" format so USD stays visible)
    const priceContainer = document.getElementById('product-price');
    if (priceContainer) {
      const moneyFormat = shopData.money_with_currency_format || shopData.money_format;
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceContainer.innerHTML = `
          <span class="product__price--sale">${formatMoney(variant.price, moneyFormat)}</span>
          <span class="product__price--compare"><s>${formatMoney(variant.compare_at_price, moneyFormat)}</s></span>
        `;
      } else {
        priceContainer.innerHTML = `<span class="product__price--regular">${formatMoney(variant.price, moneyFormat)}</span>`;
      }
    }

    const addToCartBtn = document.querySelector('.product__add-to-cart');
    if (addToCartBtn) {
      if (variant.available) {
        addToCartBtn.disabled = false;

        let span = addToCartBtn.querySelector('span');
        if (!span) {
          span = document.createElement('span');
          addToCartBtn.insertBefore(span, addToCartBtn.firstChild);
        }
        span.textContent = 'ADD TO CART';

        const icon = addToCartBtn.querySelector('svg');
        if (icon) icon.style.display = '';

      } else {
        addToCartBtn.disabled = true;

        let span = addToCartBtn.querySelector('span');
        if (!span) {
          span = document.createElement('span');
          addToCartBtn.insertBefore(span, addToCartBtn.firstChild);
        }
        span.textContent = 'SOLD OUT';

        const icon = addToCartBtn.querySelector('svg');
        if (icon) icon.style.display = 'none';
      }
    }

    // Update URL
    const url = new URL(window.location);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);

    // Update main image if variant has featured image
    if (variant.featured_image) {
      const mainImage = document.getElementById('product-main-image');
      if (mainImage) {
        mainImage.src = variant.featured_image.src.replace(/(\.[^.]+)$/, '_800x$1');
        mainImage.alt = variant.featured_image.alt || productData.title;
      }
    }

    if (typeof updateQuantityConstraints === 'function') updateQuantityConstraints();

    // Sync option UI (size + color/style) to match variant so active state is correct
    const productOptions = productData.options || [];
    productOptions.forEach((optionName, index) => {
      const value = getVariantOptionValue(variant, index);
      if (value == null) return;

      if (optionName === 'Size') {
        const sizeButtons = document.querySelectorAll('.product__size-btn.js-size-dropdown');
        sizeButtons.forEach(btn => {
          const match = (btn.dataset.optionValue === value || btn.dataset.size === value);
          btn.classList.toggle('is-active', match);
          btn.classList.toggle('active', match);
          btn.setAttribute('aria-pressed', match ? 'true' : 'false');
        });
      } else {
        const select = document.querySelector(`.product__option select[data-option-index="${index + 1}"]`);
        if (select) {
          select.value = value;
          const optionBlock = select.closest('.product__option');
          if (optionBlock) {
            const group = optionBlock.querySelector('.custom-option-buttons');
            if (group) {
              group.querySelectorAll('.custom-option-button').forEach(btn => {
                const match = (btn.dataset.value === value);
                btn.classList.toggle('active', match);
                btn.classList.toggle('is-active', match);
                btn.setAttribute('aria-pressed', match ? 'true' : 'false');
              });
            }
          }
        }
      }
    });
  }

  // Quantity: current variant and max from inventory
  function getCurrentVariant() {
    const idInput = document.getElementById('product-variant-id');
    if (!idInput || !productData.variants) return null;
    const id = parseInt(idInput.value, 10);
    return productData.variants.find((v) => v.id === id) || productData.variants[0];
  }

  function getMaxQuantity() {
    const variant = getCurrentVariant();
    if (!variant) {
      return null;
    }
    if (variant.inventory_management && variant.inventory_policy === 'deny') {
      const qty = parseInt(variant.inventory_quantity, 10);
      const result = isNaN(qty) ? null : Math.max(0, qty);
      return result;
    }
    return null;
  }

  function showQuantityHint(text) {
    // Use the single shared message element (same position as add-to-cart messages)
    const el = document.getElementById('product-add-to-cart-message')
             || document.querySelector('.product__add-to-cart-message');
    if (!el) return;
    clearTimeout(showQuantityHint._timer);
    el.textContent = text;
    el.hidden = false;
    el.classList.add('is-visible');
    showQuantityHint._timer = setTimeout(() => {
      el.classList.remove('is-visible');
      el.addEventListener('transitionend', () => {
        el.hidden = true;
        el.textContent = '';
      }, { once: true });
      setTimeout(() => { el.hidden = true; el.textContent = ''; }, 500);
    }, 2800);
  }

  function updateQuantityConstraints() {
    const qtyInput = document.getElementById('product-quantity');
    if (!qtyInput) return;
    const max = getMaxQuantity();
    if (max !== null) {
      qtyInput.setAttribute('max', String(max));
      const current = parseInt(qtyInput.value, 10) || 1;
      if (current > max) qtyInput.value = Math.max(1, max);
    } else {
      qtyInput.removeAttribute('max');
    }
  }

  // Quantity controls with clear min/max hints so +/- don't feel unresponsive
  function initQuantity() {
    const wrapper = document.querySelector('.product__quantity-wrapper');
    const minusBtn = document.querySelector('.js-qty-minus');
    const plusBtn = document.querySelector('.js-qty-plus');
    const qtyInput = document.getElementById('product-quantity');
    if (!qtyInput) return;

    const minHint = wrapper?.dataset.quantityMinHint || 'Minimum quantity is 1.';
    const maxHintOne = wrapper?.dataset.quantityMaxHintOne || 'Only 1 left in stock.';
    const maxHintTemplate = wrapper?.dataset.quantityMaxHint || 'Only {{ count }} left in stock.';

    updateQuantityConstraints();

    minusBtn?.addEventListener('click', () => {
      const current = parseInt(qtyInput.value, 10) || 1;
      if (current <= 1) {
        showQuantityHint(minHint);
        return;
      }
      qtyInput.value = current - 1;
      document.getElementById('product-quantity-hint')?.classList.remove('is-visible');
    });

    plusBtn?.addEventListener('click', () => {
      const current = parseInt(qtyInput.value, 10) || 1;
      const max = getMaxQuantity();
      if (max !== null && current >= max) {
        const msg = max === 1 ? maxHintOne : maxHintTemplate.replace(/\{\{\s*count\s*\}\}/g, String(max));
        showQuantityHint(msg);
        return;
      }
      qtyInput.value = current + 1;
      document.getElementById('product-quantity-hint')?.classList.remove('is-visible');
    });

    qtyInput.addEventListener('change', () => {
      const max = getMaxQuantity();
      let val = parseInt(qtyInput.value, 10) || 1;
      if (val < 1) {
        qtyInput.value = 1;
        showQuantityHint(minHint);
        return;
      }
      if (max !== null && val > max) {
        qtyInput.value = max;
        const msg = max === 1 ? maxHintOne : maxHintTemplate.replace(/\{\{\s*count\s*\}\}/g, String(max));
        showQuantityHint(msg);
      }
    });
  }

  /**
   * Shows a message in the single shared .product__add-to-cart-message element.
   *
   * @param {HTMLElement} form
   * @param {string} text  - message to display
   * @param {number} [duration=4000] - ms before auto-hide (0 = stay indefinitely)
   */
  function showAddToCartMessage(form, text, duration = 4000) {
    const el = form.querySelector('.product__add-to-cart-message')
              || document.getElementById('product-add-to-cart-message');
    if (!el) {
      return;
    }

    // Cancel any running hide timer so previous message doesn't cut this one short
    clearTimeout(showAddToCartMessage._timer);

    // Swap text and make visible
    el.textContent = text;
    el.hidden = false;
    el.classList.add('is-visible');

    if (duration > 0) {
      showAddToCartMessage._timer = setTimeout(() => {
        el.classList.remove('is-visible');
        // Wait for CSS transition to finish before hiding from layout
        el.addEventListener('transitionend', () => {
          el.hidden = true;
          el.textContent = '';
        }, { once: true });
        // Fallback in case transitionend never fires (no CSS transition defined)
        showAddToCartMessage._hideTimer = setTimeout(() => {
          el.hidden = true;
          el.textContent = '';
        }, 500);
      }, duration);
    }
  }

  /**
   * Returns the current quantity of a variant already in the cart.
   * @param {number|string} variantId
   * @returns {Promise<number>}
   */
  async function getCartQuantityForVariant(variantId) {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const id = parseInt(variantId, 10);
      const item = (cart.items || []).find(i => i.variant_id === id || i.id === id);
      const qty = item ? item.quantity : 0;
      return qty;
    } catch (err) {
      return 0;
    }
  }

  // AJAX Add to Cart
  function initAddToCart() {
    const form = document.getElementById('product-form');
    if (!form) return;

    // ✅ Prevent letters in number field
    const numberInput = document.getElementById('personalization-number');
    if (numberInput) {
      numberInput.addEventListener('keypress', function (e) {
        if (!/[0-9]/.test(e.key)) {
          e.preventDefault();
        }
      });

      // ✅ Also clean on paste
      numberInput.addEventListener('paste', function (e) {
        e.preventDefault();
        const pasted = (e.clipboardData || window.clipboardData).getData('text');
        const numbersOnly = pasted.replace(/[^0-9]/g, '').slice(0, 3);
        this.value = numbersOnly;
      });

      // ✅ Enforce max 3 digits
      numberInput.addEventListener('input', function () {
        if (this.value.length > 3) {
          this.value = this.value.slice(0, 3);
        }
      });
    }

    form.addEventListener('submit', async function (e) {
      e.preventDefault();

      const submitBtn = form.querySelector('.product__add-to-cart');
      const span = submitBtn.querySelector('span');

      // Store original text from span, or fallback to button textContent
      const originalText = span ? span.textContent : submitBtn.textContent;

      // Get personalization inputs and state. Use active tab to determine selection (avoids duplicate-ID / wrong-panel issues).
      const numberInput = document.getElementById('personalization-number');
      const nameInput = document.getElementById('personalization-name');
      const activeStyleTab = form.querySelector('.js-style-tab.active') || form.querySelector('.js-style-tab.is-active') || form.querySelector('.custom-option-button.active');
      const isPersonalizationSelected = activeStyleTab && activeStyleTab.classList.contains('js-personalization-dropdown');

      // Validate personalization only when the personalized option is currently selected (not when user switched to Sportrobes)
      if (isPersonalizationSelected && (numberInput || nameInput)) {
        let isValid = true;
        const errors = [];

        // Clear previous error messages
        const existingErrors = form.querySelectorAll('.personalization-error');
        existingErrors.forEach(err => err.remove());

        // Validate Number field (must be integer if provided)
        if (numberInput) {
          const numberValue = numberInput.value.trim();
          if (numberValue !== '') {
            const number = parseInt(numberValue, 10);
            if (isNaN(number) || number.toString() !== numberValue || number < 0) {
              isValid = false;
              errors.push({ field: numberInput, message: 'Number must be a valid positive integer' });
            }
          }
        }

        // Validate Name field (must be string if provided)
        if (nameInput) {
          const nameValue = nameInput.value.trim();
          if (nameValue !== '') {
            // Name should only contain letters, spaces, and common name characters
            const namePattern = /^[a-zA-Z\s'-]+$/;
            if (!namePattern.test(nameValue)) {
              isValid = false;
              errors.push({ field: nameInput, message: 'Name must contain only letters, spaces, hyphens, and apostrophes' });
            }
          }
        }

        // Show errors if validation failed
        if (!isValid) {
          submitBtn.disabled = false;
          errors.forEach(error => {
            const errorDiv = document.createElement('div');
            errorDiv.className = 'personalization-error';
            errorDiv.style.color = 'red';
            errorDiv.style.fontSize = '14px';
            errorDiv.style.marginTop = '5px';
            errorDiv.textContent = error.message;
            error.field.parentElement.appendChild(errorDiv);
            error.field.style.borderColor = 'red';

            // Remove error styling on input
            error.field.addEventListener('input', function () {
              this.style.borderColor = '';
              const errorMsg = this.parentElement.querySelector('.personalization-error');
              if (errorMsg) errorMsg.remove();
            }, { once: true });
          });
          return;
        }
      }

      submitBtn.disabled = true;

      // Update only span text if it exists, otherwise update button textContent
      if (span) {
        span.textContent = 'ADDING...';
      } else {
        submitBtn.textContent = 'ADDING...';
      }

      const formData = new FormData(form);

      // ─── Inventory-aware pre-check ───────────────────────────────────────────
      const variantId = formData.get('id');
      const requestedQty = parseInt(formData.get('quantity') || '1', 10);
      const maxQty = getMaxQuantity();

      if (maxQty !== null) {
        const cartQty = await getCartQuantityForVariant(variantId);

        // Scenario 1: Item is already at max in the cart — nothing would be added.
        if (cartQty >= maxQty) {
          showQuantityHint('Maximum quantity reached in your cart.');
          if (span) span.textContent = originalText;
          else submitBtn.textContent = originalText;
          submitBtn.disabled = false;
          return;
        }

        if (cartQty + requestedQty > maxQty) {
          const willAdd = maxQty - cartQty;
          formData.set('quantity', String(willAdd));
          form.dataset._partialAdd = String(willAdd);
        } else {
          delete form.dataset._partialAdd;
        }
      } else {
        delete form.dataset._partialAdd;
      }
      // ─────────────────────────────────────────────────────────────────────────

      // Collect and filter properties
      const properties = {};
      const keysToDelete = [];

      // First pass: collect all property entries
      for (const [key, value] of formData.entries()) {
        if (key.startsWith('properties[')) {
          keysToDelete.push(key);
          // Extract property name from 'properties[Name]' format
          const propName = key.match(/properties\[(.+)\]/)?.[1];
          if (propName && value && value.toString().trim() !== '') {
            let processedValue = value.toString().trim();

            // Ensure Number is stored as integer string
            if (propName === 'Number') {
              processedValue = parseInt(processedValue, 10).toString();
            }

            properties[propName] = processedValue;
          }
        }
      }

      // Remove all property entries
      keysToDelete.forEach(key => formData.delete(key));

      // Add back only non-empty properties; skip Number/Name when team (non-personalized) is selected
      for (const [propName, propValue] of Object.entries(properties)) {
        if ((propName === 'Number' || propName === 'Name') && !isPersonalizationSelected) continue;
        formData.append(`properties[${propName}]`, propValue);
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        const responseData = await response.json().catch(() => ({}));

        if (response.ok) {
          const partialAdd = form.dataset._partialAdd ? parseInt(form.dataset._partialAdd, 10) : null;
          delete form.dataset._partialAdd;

          if (partialAdd !== null) {
            showAddToCartMessage(
              form,
              `Only ${partialAdd} item${partialAdd !== 1 ? 's were' : ' was'} added to your cart due to availability.`
            );
          }

          if (span) {
            span.textContent = 'ADDED!';
          } else {
            submitBtn.textContent = 'ADDED!';
          }

          setTimeout(() => {
            if (span) {
              span.textContent = originalText;
            } else {
              submitBtn.textContent = originalText;
            }
            submitBtn.disabled = false;
          }, 2000);

          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: {
              cart: {
                item_count: cart.item_count
              }
            }
          }));

        } else {
          // Error response - parse Shopify's error message
          const errorMessage = responseData.message ||
                              responseData.description ||
                              form.dataset.addToCartMaxMessage ||
                              'Unable to add item to cart. Please try again.';

          showAddToCartMessage(form, errorMessage);
          if (span) span.textContent = originalText;
          else submitBtn.textContent = originalText;
          submitBtn.disabled = false;
          delete form.dataset._partialAdd;
          return;
        }
      } catch (error) {
        showAddToCartMessage(form, form.dataset.addToCartMaxMessage || 'Unable to add item to cart. Please try again.');
        if (span) span.textContent = originalText;
        else submitBtn.textContent = originalText;
        submitBtn.disabled = false;
        delete form.dataset._partialAdd;
      }
    });
  }

  // Size Chart Modal
  function initSizeChart() {
    const openBtns = document.querySelectorAll('.js-size-chart-open');
    const closeBtns = document.querySelectorAll('.js-size-chart-close');
    const modal = document.getElementById('size-chart-modal');

    if (!modal) return;

    openBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
    });

    closeBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      });
    });

    // Close on escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    });
  }

  // Format money helper
  // Uses Shopify's standard money formatting approach
  function formatMoney(cents, format) {
    const amount = cents / 100;

    // Priority 1: Use Shopify.formatMoney if available (legacy support)
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      const moneyFormat = format ||
        shopData.money_format ||
        window.Shopify?.money_format ||
        '{{amount}}';
      return Shopify.formatMoney(cents, moneyFormat);
    }

    // Priority 2: Use Shopify money format string if available
    const moneyFormat = format || shopData.money_format || window.Shopify?.money_format;
    if (moneyFormat) {
      return moneyFormat.replace('{{amount}}', amount.toFixed(2))
        .replace('{{amount_no_decimals}}', Math.round(amount).toString())
        .replace('{{amount_with_comma_separator}}', amount.toFixed(2).replace('.', ','))
        .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(amount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
    }

    // Priority 3: Use Intl.NumberFormat with currency from shop data
    const currency = shopData.currency ||
      window.Shopify?.currency?.active ||
      window.Shopify?.shop?.currency ||
      'USD';

    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    return formatter.format(amount);
  }

  // Initialize all
  function init() {
    initGallery();
    initLeagueSelector();
    initStyleLeagueSelector();
    initStyleTabs();
    syncStyleTabsWithVariant();
    initSizeSelector();
    initQuantity();
    initAddToCart();
    initSizeChart();

    document.querySelectorAll('.product__option select').forEach(select => {
      select.addEventListener('change', updateVariant);
    });

    // Set initial option availability and variant (e.g. disable XL when only Large exists for selected color)
    updateVariant();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

document.addEventListener('DOMContentLoaded', function () {
  const img = document.getElementById('product-main-image');
  const btn = document.querySelector('.product__expand-btn');
  if (!img || !btn) return;

  let isDragging = false;
  let startX, startY;
  let imgX = 0, imgY = 0;

  // ✅ Toggle zoom in/out on button click
  btn.addEventListener('click', (e) => {
    e.stopPropagation();

    if (img.classList.contains('expanded')) {
      // 2nd click — zoom out
      img.classList.remove('expanded');
      img.style.transform = 'translate(0px, 0px) scale(1)';
      imgX = 0;
      imgY = 0;
      img.style.cursor = 'default';
    } else {
      // 1st click — zoom in
      img.classList.add('expanded');
      img.style.transform = 'translate(0px, 0px) scale(2)';
      imgX = 0;
      imgY = 0;
    }
  });

  img.addEventListener('mousedown', (e) => {
    if (!img.classList.contains('expanded')) return;
    isDragging = true;
    startX = e.clientX - imgX;
    startY = e.clientY - imgY;
    img.style.cursor = 'grabbing';
    e.preventDefault();
  });

  document.addEventListener('mousemove', (e) => {
    if (!isDragging) return;
    imgX = e.clientX - startX;
    imgY = e.clientY - startY;
    img.style.transform = `translate(${imgX}px, ${imgY}px) scale(2)`;
  });

  document.addEventListener('mouseup', () => {
    if (!isDragging) return;
    isDragging = false;
    img.style.cursor = 'grab';
  });

  document.addEventListener('click', (e) => {
    if (!img.classList.contains('expanded')) return;
    if (img.contains(e.target) || e.target === btn || btn.contains(e.target)) return;
    img.classList.remove('expanded');
    img.style.transform = 'translate(0px, 0px) scale(1)';
    imgX = 0;
    imgY = 0;
    img.style.cursor = 'default';
  });
});